// #region Imports
//Components
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-text-area',
    mixins: [host.mixins.form],
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
        rows: {
            type: Number,
            required: false,
            default: 3
        },
        isAutoFill: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    methods: {
        onEnterKey(event) {
            this.$emit('EnterKey', event);
        },
    }
});
// #endregion
